import React, { useState } from 'react';
import { Button, VStack } from 'native-base';
import { graphql } from '../../__generated__';
import { useQuery } from '@apollo/client';
import { OrdersTable } from '../components/Table/OrdersTable';
import { Fulfillment } from '../../__generated__/graphql';

const limit = 20;

export const shippedQuery = graphql(`
  query completedFulfillments($offset: Int, $limit: Int) {
    fulfilmentsCompleted(offset: $offset, limit: $limit) {
      id
      createdAt
      total
      dispensed
      completed
      booked
      items {
        QTY
        ID
        PrescriptionID
      }
      street
      shipping
      subtotal
      suburb
      state
      postcode
      total
      suburb
      prescriptionIDs
      creatingRole
      creatingRole
      deliveryMethod
      isPayInPerson
      customer {
        id
        given
        dob
        brand
        mobile
        name
      }
    }
  }
`);

export default function () {
  const { data, loading, fetchMore } = useQuery(shippedQuery, {
    fetchPolicy: 'cache-and-network',
    variables: {
      offset: 0,
      limit,
    },
  });

  const [loadingMore, setLoadingMore] = useState(false);

  const canLoadMore = !loading && (data?.fulfilmentsCompleted?.length ?? 0) >= limit;

  const loadMore = async () => {
    setLoadingMore(true);

    await fetchMore({
      variables: {
        offset: data?.fulfilmentsCompleted?.length,
        open,
      },
    });

    setLoadingMore(false);
  };

  return (
    <VStack flex={1}>
      <OrdersTable orders={data?.fulfilmentsCompleted as Fulfillment[]} loading={loading} />

      {canLoadMore && (
        <Button
          isLoading={loadingMore}
          isDisabled={loadingMore}
          variant={'outline'}
          onPress={loadMore}
        >
          Load More
        </Button>
      )}
    </VStack>
  );
}
